export default __webpack_public_path__ + "static/media/map.90d8127b.svg";